export default {
  buttons: {
    send_code: 'Send Login Code',
  },
  placeholders: {
    mobile_number: 'Mobile Number',
    email: 'Email Address',
  },
  feedback: {
    phone_number_required: 'Please enter your phone number',
    email_required: 'Please enter your email address',
  },
};
